export class WareHouse {
  constructor(
    public id: number = null,
    public companies_id: number = null,
    public name: string = "",
    public address: string = "",
    public address2: string = "",
    public colonia: string = "",
    public city: string = "",
    public zipCode: string = "",
    public country: string = "",
    public phone: string = "",
    public mobilePhone: string = "",
    public activo: number = 1,
    public contactName: string = "",
    public email: string = "",
    public state: string = "",
    public iqName: string = "",
    public defaultLocation: any = 0
  ) {}
}
